// Hook to fetch /directions data (public). Merges defaults coming from the
// backend with any CMS overrides — the backend already does the merge, so
// the FE just needs to map slugs to the static `HOTELS` registry to render
// human-readable names + categories.
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export const useDirections = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetch(`${API}/api/directions`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        if (cancelled) return;
        setItems(Array.isArray(data?.items) ? data.items : []);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || "Failed to load directions");
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { items, loading, error };
};
